export default function QrCodeScanIcon({
  width,
  height,
  innerColor,
}: {
  width: React.CSSProperties["width"];
  height: React.CSSProperties["height"];
  innerColor: React.CSSProperties["fill"];
}) {
  return (
    <div style={{ width, height }}>
      <svg viewBox="0 0 3000 4000">
        <g id="g53" transform="matrix(1.5155881,0,0,1.4802976,-1665.8843,-1012.3712)">
          <path
            className="st2"
            d="m 2176.02,2587.68 c -2.41,-1.06 -4.98,-1.6 -7.62,-1.6 -5.32,0 -10.42,2.24 -14,6.16 -1.38,1.52 -2.52,3.28 -3.38,5.22 -19.96,45.51 -56.88,111.47 -81.69,138.62 -31.57,34.55 -61.03,45.87 -84.7,54.97 -7.86,3.03 -15.28,5.89 -21.9,9.35 -12.4,6.29 -23.45,14.72 -32.94,25.11 -13.79,15.09 -20.29,30.12 -21.95,34.37 l -0.14,0.34 -47.49,108.21 -456.65,-200.39 5.4,-13.74 c 4.42,-11.28 6.93,-23.65 7.43,-36.77 l 0.02,-0.55 0.09,-0.54 c 2.69,-16.77 -0.78,-35.46 -4.45,-55.24 l -0.54,-2.91 c -7.23,-39.02 -19.14,-77.69 -31.74,-118.63 -9.61,-31.24 -19.55,-63.53 -28.02,-97.96 -45.71,-180.34 -58.63,-307.22 -38.41,-377.03 16.3,-56.3 14.23,-110.14 12.57,-153.4 l -0.01,-0.17 c -1.51,-39.8 -2.71,-71.24 9.68,-88.1 9.27,-12.62 20.5,-18.5 35.33,-18.5 h 0.73 c 30.47,0.4 69.49,26.23 94.9,62.81 44.95,64.72 55.72,128.99 36.01,214.92 -1.02,4.46 -0.4,9.16 1.77,13.21 9.09,17.06 32.73,69.79 32.92,108.57 0.01,3.18 0.79,6.2 2.29,8.97 l 0.59,1.08 0.28,1.2 c 1.19,5.08 4.31,9.3 8.78,11.89 3.02,1.77 73.37,43.56 126.68,115.98 70.39,95.64 79.28,197.98 26.42,304.17 -2.22,4.45 -2.57,9.5 -0.98,14.22 1.59,4.72 4.9,8.53 9.35,10.75 1.94,0.98 4.01,1.59 6.15,1.84 0.71,0.08 1.42,0.12 2.13,0.12 7.13,0 13.52,-3.96 16.69,-10.33 59.04,-118.6 48.36,-237.66 -30.86,-344.32 -46.41,-62.48 -103.46,-103.16 -125.84,-117.75 l -3.81,-2.48 -0.31,-4.55 c -2.85,-42.53 -23.01,-88.5 -31.54,-106.28 l -2.23,-4.63 1.03,-5.06 c 18.04,-89.48 3.93,-163.57 -44.39,-233.14 -27.02,-38.9 -76.31,-78.44 -125.52,-79.08 -0.39,-0.01 -0.78,-0.01 -1.17,-0.01 -26.44,0 -49.87,12.06 -65.96,33.97 -20.23,27.55 -18.72,66.79 -16.98,112.22 1.63,42.68 3.47,90.98 -11.12,141.35 -34.91,120.49 23.19,345.37 41.83,411.42 l 0.81,2.91 c 7.88,31.48 16.49,58.88 24.83,85.38 l 0.1,0.33 c 11.46,36.39 22.28,70.76 29.74,111.04 3.33,17.98 3.44,57.59 1.01,70.88 l -0.13,0.72 -5.77,16.23 -33.61,-14.76 c -2.43,-1.07 -4.99,-1.61 -7.63,-1.61 -5.3,0 -10.4,2.25 -13.97,6.17 -1.39,1.52 -2.52,3.27 -3.37,5.19 l -129.42,294.94 c -2.03,4.63 -2.14,9.77 -0.3,14.49 1.84,4.73 5.41,8.45 10.04,10.49 L 1814,3341.3 c 2.43,1.07 4.99,1.61 7.63,1.61 5.3,0 10.39,-2.25 13.97,-6.17 1.4,-1.53 2.52,-3.26 3.34,-5.16 l 129.44,-294.98 c 2.04,-4.64 2.15,-9.78 0.31,-14.5 -1.83,-4.72 -5.4,-8.43 -10.04,-10.46 l -63.74,-27.97 48.17,-109.78 c 0.02,-0.06 0.07,-0.2 0.15,-0.43 l 0.16,-0.43 c 1.05,-2.61 5.2,-11.89 14.19,-21.75 6.54,-7.15 14.11,-12.94 22.52,-17.22 8.33,-4.35 17.32,-8.18 26.02,-11.89 27.5,-11.76 58.68,-25.09 91.89,-61.44 27.37,-29.94 66.1,-98.81 87.73,-148.1 4.21,-9.54 -0.15,-20.74 -9.72,-24.95 z m -249.94,451.06 -114.21,260.23 -588.2,-258.12 114.21,-260.22 z"
            id="path12"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 2352.44,872.69 h -670.42 c -68.96,0 -125.07,56.11 -125.07,125.07 v 778.98 c 0,10.59 8.62,19.21 19.21,19.21 10.59,0 19.21,-8.62 19.21,-19.21 V 997.76 c 0,-47.78 38.87,-86.66 86.65,-86.66 h 670.42 c 47.77,0 86.63,38.87 86.63,86.66 v 1088.3 30.31 279.8 c 0,47.77 -38.86,86.63 -86.63,86.63 H 1878.3 c -10.59,0 -19.21,8.62 -19.21,19.21 0,10.6 8.62,19.21 19.21,19.21 h 474.15 c 68.95,0 125.05,-56.1 125.05,-125.06 v -279.8 -30.31 -1088.29 c 0,-68.96 -56.1,-125.07 -125.06,-125.07 z"
            id="path13"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 1787.6,1879.71 c 0,8.93 7.27,16.2 16.2,16.2 h 105.09 c 8.93,0 16.2,-7.27 16.2,-16.2 v -105.09 c 0,-8.93 -7.27,-16.2 -16.2,-16.2 H 1803.8 c -8.93,0 -16.2,7.27 -16.2,16.2 z m 32.4,-88.89 h 72.69 v 72.69 H 1820 Z"
            id="path14"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 1908.9,1438.97 h -105.1 c -8.93,0 -16.2,7.27 -16.2,16.2 v 105.09 c 0,8.93 7.27,16.2 16.2,16.2 h 105.09 c 8.93,0 16.2,-7.27 16.2,-16.2 v -105.09 c 0.01,-8.93 -7.26,-16.2 -16.19,-16.2 z m -16.2,105.1 H 1820 v -72.69 h 72.69 v 72.69 z"
            id="path15"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 2107.05,1455.17 v 105.1 c 0,8.93 7.27,16.2 16.2,16.2 h 105.09 c 8.93,0 16.2,-7.27 16.2,-16.2 v -105.1 c 0,-8.93 -7.27,-16.2 -16.2,-16.2 h -105.09 c -8.94,0 -16.2,7.27 -16.2,16.2 z m 32.4,16.2 h 72.69 v 72.69 h -72.69 z"
            id="path16"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 1967.55,1438.97 c -8.93,0 -16.2,7.27 -16.2,16.2 v 52.55 c 0,8.93 7.27,16.2 16.2,16.2 h 48.52 c 8.93,0 16.2,-7.27 16.2,-16.2 0,-8.93 -7.27,-16.2 -16.2,-16.2 h -32.32 v -36.35 c 0,-8.93 -7.26,-16.2 -16.2,-16.2 z"
            id="path17"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 1803.8,1632.72 h 36.26 c 8.93,0 16.2,-7.27 16.2,-16.2 0,-8.93 -7.27,-16.2 -16.2,-16.2 h -36.26 c -8.93,0 -16.2,7.27 -16.2,16.2 0,8.93 7.27,16.2 16.2,16.2 z"
            id="path18"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 1892.7,1616.52 v 50.92 c 0,8.93 7.27,16.2 16.2,16.2 8.93,0 16.2,-7.27 16.2,-16.2 v -34.72 h 42.46 c 8.93,0 16.2,-7.27 16.2,-16.2 v -56.25 c 0,-8.93 -7.27,-16.2 -16.2,-16.2 -8.93,0 -16.2,7.27 -16.2,16.2 v 40.05 h -42.45 c -8.95,0 -16.21,7.27 -16.21,16.2 z"
            id="path19"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 2082.38,1616.52 v -56.25 c 0,-8.93 -7.27,-16.2 -16.2,-16.2 h -50.11 c -8.93,0 -16.2,7.27 -16.2,16.2 0,8.93 7.27,16.2 16.2,16.2 h 33.91 v 23.85 h -33.91 c -8.93,0 -16.2,7.27 -16.2,16.2 v 34.72 h -32.32 c -8.93,0 -16.2,7.27 -16.2,16.2 v 47.7 c 0,8.93 7.27,16.2 16.2,16.2 8.93,0 16.2,-7.27 16.2,-16.2 v -31.5 h 32.32 c 8.93,0 16.2,-7.27 16.2,-16.2 v -34.72 h 33.91 c 8.93,0 16.2,-7.27 16.2,-16.2 z"
            id="path20"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 2066.18,1523.92 c 8.93,0 16.2,-7.27 16.2,-16.2 v -52.55 c 0,-8.93 -7.27,-16.2 -16.2,-16.2 h -25.05 c -8.93,0 -16.2,7.27 -16.2,16.2 0,8.93 7.27,16.2 16.2,16.2 h 8.85 v 36.35 c 0,8.93 7.27,16.2 16.2,16.2 z"
            id="path21"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 1787.6,1715.14 c 0,8.93 7.27,16.2 16.2,16.2 8.93,0 16.2,-7.27 16.2,-16.2 v -47.7 c 0,-8.93 -7.27,-16.2 -16.2,-16.2 -8.93,0 -16.2,7.27 -16.2,16.2 z"
            id="path22"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 1908.9,1710.97 h -26.18 v -31.91 c 0,-8.93 -7.27,-16.2 -16.2,-16.2 -8.93,0 -16.2,7.27 -16.2,16.2 v 48.11 c 0,8.93 7.27,16.2 16.2,16.2 h 42.38 c 8.93,0 16.2,-7.27 16.2,-16.2 0,-8.93 -7.27,-16.2 -16.2,-16.2 z"
            id="path23"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 1967.55,1790.82 h 48.52 c 8.93,0 16.2,-7.27 16.2,-16.2 v -47.44 c 0,-8.93 -7.27,-16.2 -16.2,-16.2 -8.93,0 -16.2,7.27 -16.2,16.2 v 31.24 h -32.32 c -8.93,0 -16.2,7.27 -16.2,16.2 0,8.93 7.27,16.2 16.2,16.2 z"
            id="path24"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 1967.55,1863.51 c -8.93,0 -16.2,7.27 -16.2,16.2 0,8.93 7.27,16.2 16.2,16.2 h 49.31 c 8.93,0 16.2,-7.27 16.2,-16.2 v -52.55 c 0,-8.93 -7.27,-16.2 -16.2,-16.2 h -49.31 c -8.93,0 -16.2,7.27 -16.2,16.2 0,8.93 7.27,16.2 16.2,16.2 h 33.11 v 20.14 h -33.11 z"
            id="path25"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 2123.25,1653.91 h 31.94 c 8.93,0 16.2,-7.27 16.2,-16.2 0,-8.93 -7.27,-16.2 -16.2,-16.2 h -31.94 c -8.93,0 -16.2,7.27 -16.2,16.2 0,8.93 7.26,16.2 16.2,16.2 z"
            id="path26"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 2159.59,1840.23 c 0,8.93 7.27,16.2 16.2,16.2 h 36.35 v 23.28 c 0,8.93 7.27,16.2 16.2,16.2 8.93,0 16.2,-7.27 16.2,-16.2 v -39.48 c 0,-8.93 -7.27,-16.2 -16.2,-16.2 h -36.35 v -49.42 c 0,-8.93 -7.27,-16.2 -16.2,-16.2 -8.93,0 -16.2,7.27 -16.2,16.2 z"
            id="path27"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 2123.25,1843.37 c 8.93,0 16.2,-7.27 16.2,-16.2 0,-8.93 -7.27,-16.2 -16.2,-16.2 h -28.53 c -8.93,0 -16.2,7.27 -16.2,16.2 v 36.34 h -12.33 c -8.93,0 -16.2,7.27 -16.2,16.2 0,8.93 7.27,16.2 16.2,16.2 h 57.07 c 8.93,0 16.2,-7.27 16.2,-16.2 0,-8.93 -7.27,-16.2 -16.2,-16.2 h -12.33 v -20.14 h 12.32 z"
            id="path28"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 2107.05,1758.42 h -24.66 v -90.97 c 0,-8.93 -7.27,-16.2 -16.2,-16.2 -8.93,0 -16.2,7.27 -16.2,16.2 v 107.17 c 0,8.93 7.27,16.2 16.2,16.2 h 57.07 c 8.93,0 16.2,-7.27 16.2,-16.2 v -71.5 c 0,-8.93 -7.27,-16.2 -16.2,-16.2 -8.93,0 -16.2,7.27 -16.2,16.2 v 55.3 z"
            id="path29"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 2159.59,1715.14 c 0,8.93 7.27,16.2 16.2,16.2 h 36.35 v 43.27 c 0,8.93 7.27,16.2 16.2,16.2 8.93,0 16.2,-7.27 16.2,-16.2 v -83.32 c 0,-8.93 -7.27,-16.2 -16.2,-16.2 -8.93,0 -16.2,7.27 -16.2,16.2 v 7.65 h -36.35 c -8.93,0 -16.2,7.27 -16.2,16.2 z"
            id="path30"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 2228.34,1659.03 c 8.93,0 16.2,-7.27 16.2,-16.2 v -28.98 c 0,-8.93 -7.27,-16.2 -16.2,-16.2 h -26.27 c -8.93,0 -16.2,7.27 -16.2,16.2 0,8.93 7.27,16.2 16.2,16.2 h 10.07 v 12.78 c 0,8.93 7.27,16.2 16.2,16.2 z"
            id="path31"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 1858.45,1354.3 h -138.24 c -9.86,0 -17.86,8 -17.86,17.86 v 138.24 c 0,9.86 7.99,17.86 17.86,17.86 9.86,0 17.86,-7.99 17.86,-17.86 v -120.38 h 120.38 c 9.86,0 17.86,-7.99 17.86,-17.86 0,-9.87 -8,-17.86 -17.86,-17.86 z"
            id="path32"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 2330.94,1372.15 c 0,-9.86 -8,-17.86 -17.86,-17.86 h -138.24 c -9.86,0 -17.86,8 -17.86,17.86 0,9.86 8,17.86 17.86,17.86 h 120.38 v 120.38 c 0,9.86 8,17.86 17.86,17.86 9.86,0 17.86,-7.99 17.86,-17.86 v -138.24 z"
            id="path33"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 1701.2,1965.03 c 0,9.86 8,17.86 17.86,17.86 h 138.24 c 9.86,0 17.86,-8 17.86,-17.86 0,-9.86 -8,-17.86 -17.86,-17.86 h -120.38 v -120.38 c 0,-9.86 -8,-17.86 -17.86,-17.86 -9.86,0 -17.86,7.99 -17.86,17.86 v 138.24 z"
            id="path34"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 2173.69,1982.89 h 138.24 c 9.86,0 17.86,-8 17.86,-17.86 v -138.24 c 0,-9.86 -8,-17.86 -17.86,-17.86 -9.86,0 -17.86,7.99 -17.86,17.86 v 120.38 h -120.38 c -9.86,0 -17.86,8 -17.86,17.86 0,9.87 8,17.86 17.86,17.86 z"
            id="path35"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 2720.98,1741.33 h 105.09 c 8.93,0 16.2,-7.27 16.2,-16.2 v -105.1 c 0,-8.93 -7.27,-16.2 -16.2,-16.2 h -105.09 c -8.93,0 -16.2,7.27 -16.2,16.2 v 105.1 c 0,8.94 7.27,16.2 16.2,16.2 z m 16.21,-105.09 h 72.69 v 72.69 h -72.69 z"
            id="path36"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 2565.29,1688.79 h 48.52 c 8.93,0 16.2,-7.27 16.2,-16.2 0,-8.93 -7.27,-16.2 -16.2,-16.2 h -32.32 v -36.35 c 0,-8.93 -7.27,-16.2 -16.2,-16.2 -8.93,0 -16.2,7.27 -16.2,16.2 v 52.55 c 0,8.93 7.27,16.2 16.2,16.2 z"
            id="path37"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 2565.29,1896.21 c 8.93,0 16.2,-7.27 16.2,-16.2 v -31.5 h 32.32 c 8.93,0 16.2,-7.27 16.2,-16.2 v -34.72 h 33.91 c 8.93,0 16.2,-7.27 16.2,-16.2 v -56.25 c 0,-8.93 -7.27,-16.2 -16.2,-16.2 h -50.11 c -8.93,0 -16.2,7.27 -16.2,16.2 0,8.93 7.27,16.2 16.2,16.2 h 33.91 v 23.85 h -33.91 c -8.93,0 -16.2,7.27 -16.2,16.2 v 34.72 h -32.32 c -8.93,0 -16.2,7.27 -16.2,16.2 v 47.7 c 0,8.93 7.27,16.2 16.2,16.2 z"
            id="path38"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 2622.66,1620.04 c 0,8.93 7.27,16.2 16.2,16.2 h 8.85 v 36.35 c 0,8.93 7.27,16.2 16.2,16.2 8.93,0 16.2,-7.27 16.2,-16.2 v -52.55 c 0,-8.93 -7.27,-16.2 -16.2,-16.2 h -25.05 c -8.93,0 -16.2,7.26 -16.2,16.2 z"
            id="path39"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 2565.29,1955.68 h 48.52 c 8.93,0 16.2,-7.27 16.2,-16.2 v -47.44 c 0,-8.93 -7.27,-16.2 -16.2,-16.2 -8.93,0 -16.2,7.27 -16.2,16.2 v 31.24 h -32.32 c -8.93,0 -16.2,7.27 -16.2,16.2 0,8.93 7.27,16.2 16.2,16.2 z"
            id="path40"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 2614.6,1975.83 h -49.31 c -8.93,0 -16.2,7.27 -16.2,16.2 0,8.93 7.27,16.2 16.2,16.2 h 33.11 v 20.14 h -33.11 c -8.93,0 -16.2,7.27 -16.2,16.2 0,8.93 7.27,16.2 16.2,16.2 h 49.31 c 8.93,0 16.2,-7.27 16.2,-16.2 v -52.55 c 0.01,-8.92 -7.26,-16.19 -16.2,-16.19 z"
            id="path41"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 2769.12,1802.57 c 0,-8.93 -7.27,-16.2 -16.2,-16.2 h -31.94 c -8.93,0 -16.2,7.27 -16.2,16.2 0,8.93 7.27,16.2 16.2,16.2 h 31.94 c 8.93,0 16.2,-7.27 16.2,-16.2 z"
            id="path42"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 2826.08,2060.78 c 8.93,0 16.2,-7.27 16.2,-16.2 v -39.48 c 0,-8.93 -7.27,-16.2 -16.2,-16.2 h -36.35 v -49.42 c 0,-8.93 -7.27,-16.2 -16.2,-16.2 -8.93,0 -16.2,7.27 -16.2,16.2 v 65.62 c 0,8.93 7.27,16.2 16.2,16.2 h 36.35 v 23.28 c 0,8.93 7.26,16.2 16.2,16.2 z"
            id="path43"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 2720.98,2008.23 c 8.93,0 16.2,-7.27 16.2,-16.2 0,-8.93 -7.27,-16.2 -16.2,-16.2 h -28.53 c -8.93,0 -16.2,7.27 -16.2,16.2 v 36.34 h -12.33 c -8.93,0 -16.2,7.27 -16.2,16.2 0,8.93 7.27,16.2 16.2,16.2 h 57.07 c 8.93,0 16.2,-7.27 16.2,-16.2 0,-8.93 -7.27,-16.2 -16.2,-16.2 h -12.33 v -20.14 h 12.32 z"
            id="path44"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 2720.98,1851.78 c -8.93,0 -16.2,7.27 -16.2,16.2 v 55.3 h -24.66 v -90.97 c 0,-8.93 -7.27,-16.2 -16.2,-16.2 -8.93,0 -16.2,7.27 -16.2,16.2 v 107.17 c 0,8.93 7.27,16.2 16.2,16.2 h 57.07 c 8.93,0 16.2,-7.27 16.2,-16.2 v -71.5 c 0,-8.93 -7.27,-16.2 -16.21,-16.2 z"
            id="path45"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 2842.28,1856.16 c 0,-8.93 -7.27,-16.2 -16.2,-16.2 -8.93,0 -16.2,7.27 -16.2,16.2 v 7.65 h -36.35 c -8.93,0 -16.2,7.27 -16.2,16.2 0,8.93 7.27,16.2 16.2,16.2 h 36.35 v 43.27 c 0,8.93 7.27,16.2 16.2,16.2 8.93,0 16.2,-7.27 16.2,-16.2 z"
            id="path46"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 2842.28,1778.72 c 0,-8.93 -7.27,-16.2 -16.2,-16.2 h -26.27 c -8.93,0 -16.2,7.27 -16.2,16.2 0,8.93 7.27,16.2 16.2,16.2 h 10.07 v 12.78 c 0,8.93 7.27,16.2 16.2,16.2 8.93,0 16.2,-7.27 16.2,-16.2 z"
            id="path47"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 2910.82,1519.16 h -138.24 c -9.86,0 -17.86,8 -17.86,17.86 0,9.86 8,17.86 17.86,17.86 h 120.38 v 120.38 c 0,9.86 8,17.86 17.86,17.86 9.86,0 17.86,-7.99 17.86,-17.86 v -138.24 c 0,-9.86 -7.99,-17.86 -17.86,-17.86 z"
            id="path48"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 2909.67,1973.8 c -9.86,0 -17.86,7.99 -17.86,17.86 v 120.38 h -120.38 c -9.86,0 -17.86,8 -17.86,17.86 0,9.86 8,17.86 17.86,17.86 h 138.24 c 9.86,0 17.86,-8 17.86,-17.86 v -138.24 c 0,-9.87 -8,-17.86 -17.86,-17.86 z"
            id="path49"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 2067.59,991.11 h -99.15 c -10.77,0 -19.5,8.73 -19.5,19.5 0,10.77 8.73,19.5 19.5,19.5 h 99.15 c 10.77,0 19.5,-8.73 19.5,-19.5 0,-10.77 -8.73,-19.5 -19.5,-19.5 z"
            id="path50"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 2631.76,1174.24 c 0.02,0 0.03,0 0.05,0 10.75,0 19.47,-8.7 19.5,-19.45 l 0.3,-128.5 c 0.03,-10.77 -8.68,-19.52 -19.45,-19.55 -0.02,0 -0.03,0 -0.05,0 -10.75,0 -19.47,8.7 -19.5,19.45 l -0.3,128.5 c -0.03,10.77 8.68,19.52 19.45,19.55 z"
            id="path51"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 2935.45,1305.43 -128.5,-0.3 c -0.02,0 -0.03,0 -0.05,0 -10.75,0 -19.47,8.7 -19.5,19.45 -0.03,10.77 8.68,19.52 19.45,19.55 l 128.5,0.3 c 0.02,0 0.03,0 0.05,0 10.75,0 19.47,-8.7 19.5,-19.45 0.03,-10.77 -8.68,-19.53 -19.45,-19.55 z"
            id="path52"
            fill={innerColor}
          />
          <path
            className="st2"
            d="m 2780.08,1207.09 c 4.97,0 9.95,-1.89 13.76,-5.68 l 91.08,-90.65 c 7.63,-7.6 7.66,-19.94 0.07,-27.58 -7.6,-7.63 -19.94,-7.66 -27.58,-0.07 l -91.08,90.65 c -7.63,7.6 -7.66,19.94 -0.07,27.58 3.81,3.83 8.81,5.75 13.82,5.75 z"
            id="path53"
            fill={innerColor}
          />
        </g>
      </svg>
    </div>
  );
}
